/* C&T Mystery Zone — CT Hometown theme JS (no dependencies) */
(function () {
  'use strict';

  /* Mobile navigation toggle */
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.hasAttribute('hidden');
      if (open) {
        nav.removeAttribute('hidden');
      } else {
        nav.setAttribute('hidden', '');
      }
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Collection sort + cart quantity auto-submit live inside the
     main-collection / main-cart sections themselves (self-contained,
     so the sections also work when pasted into another theme). */

  /* Login page: toggle between login and recover-password forms */
  var loginForm = document.querySelector('[data-login-form]');
  var recoverForm = document.querySelector('[data-recover-form]');
  if (loginForm && recoverForm) {
    var showRecover = function () {
      recoverForm.removeAttribute('hidden');
      loginForm.setAttribute('hidden', '');
    };
    var showLogin = function () {
      loginForm.removeAttribute('hidden');
      recoverForm.setAttribute('hidden', '');
    };
    if (window.location.hash === '#recover') showRecover();
    document.querySelectorAll('[data-recover-toggle]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        showRecover();
        window.location.hash = 'recover';
      });
    });
    document.querySelectorAll('[data-login-toggle]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        showLogin();
        window.location.hash = 'login';
      });
    });
    /* If the recover form was just submitted successfully, keep it visible */
    if (recoverForm.querySelector('.ct-form__success')) showRecover();
  }
})();
